import React, { useState } from 'react';
import { Button, Container, Form, Spinner } from 'react-bootstrap';
import Recaptcha from 'react-google-recaptcha';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router';
import { FormField } from '../../common/Forms';
import { urlConst } from '../../../consts';
import { apiService } from '../../../services';

function ResetPassPage() {
    const [email, setEmail] = useState('');
    const [token, setToken] = useState(null);
    const [submitting, setSubmitting] = useState(false);
    const navigate = useNavigate();
    const handleSubmit = (e) => {
        e.preventDefault();
        if (!token) {
            toast.error(`Не отмечена галочка "Я не робот"`);
            return;
        }

        setSubmitting(true);
        apiService
            .post(urlConst.API_RESET_PASS, JSON.stringify({ email, token }))
            .then((data) => {
                setSubmitting(false);
                if (data.status === 'OK') {
                    navigate('/message/reset_mail_sent');
                } else if (data.status === 'user is not exists') {
                    toast.error(`Ошибка: такого пользователя нет в системе`);
                } else {
                    toast.error(`Ошибка: ${data.status}`);
                }
            })
            .catch((err) => {
                console.error(err);
                toast.error(`Ошибка: ${err.message}`);
                setSubmitting(false);
            });
    };
    const handleChange = (value) => {
        setEmail(value);
    };
    const handleRecaptcha = (value) => {
        setToken(value);
    };
    return (
        <Container className="login-page">
            <h1 className="text-center my-3">Восстановления пароля</h1>
            <div className="form-container">
                <Form onSubmit={handleSubmit}>
                    <Form.Group>
                        <FormField
                            field={{
                                id: 'username',
                                name: 'Логин',
                                inputType: 'email',
                                required: true,
                            }}
                            placeholder="Введите свой email"
                            value={email}
                            onChange={handleChange}
                        />
                    </Form.Group>
                    <Form.Group>
                        <Recaptcha
                            sitekey="6Lf7k9AUAAAAANVEeNJLMeKyZfob29_T5YHMmJii"
                            hl="ru"
                            onChange={handleRecaptcha}
                        />
                    </Form.Group>
                    <Form.Group className="text-center">
                        <Button variant="outline-primary" type="submit" className="px-5" disabled={submitting}>
                            {submitting && (
                                <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                            )}
                            <span>Восстановить</span>
                        </Button>
                    </Form.Group>
                </Form>
            </div>
        </Container>
    );
}

export default ResetPassPage;
